var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cardBox"},[(_vm.item.icon)?_c('img',{attrs:{"src":require('@/assets/img/talent/' + _vm.item.icon + '.png')}}):_vm._e(),_c('p',[_vm._v(_vm._s(_vm.item.title))]),_c('span',[_vm._v(_vm._s(_vm.item.info))])])}
var staticRenderFns = []

export { render, staticRenderFns }